import React from 'react';

import { loaderGif } from '../../../assets/images/login';
import styles from '../../../features/formAfterSignUp/FormAfterSignUp.module.css';
import { trash } from '../../../assets/images/dashboard-business';

type TProps = {
  showModal?: boolean;
  setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
  description?: string;
  deleteFn: () => void;
};
export default function DeleteModal({
  showModal = false,
  setShowModal = () => {
    return;
  },
  description = '',
  deleteFn,
}: TProps) {
  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-10 overflow-y-auto rounded-[4px]'>
            <div
              className='fixed inset-0 w-full h-full bg-black opacity-40'
              onClick={() => setShowModal(false)}
            ></div>
            <div className='flex items-center min-h-screen px-6 py-4'>
              <div className='relative p-[1.6em]  mx-auto bg-white rounded-md shadow-lg'>
                <div className='sm:mt-[1.5em] max-w-[300px] sm:flex justify-center'>
                  <div className=' text-center sm:text-left'>
                    <div className='bg-[whitesmoke] rounded-[50%] p-2 w-[40px] h-[40px] flex items-center justify-center mx-auto'>
                      <img src={trash} className='h-[30px] w-[30px]' />
                    </div>
                    <div className='text-[15px] md:text-[18px] mb-6 font-[500]'>{description}</div>

                    <div className='items-center gap-2 mt-3 flex '>
                      <button
                        onClick={() => {
                          deleteFn();
                          setShowModal(false);
                        }}
                        className={[
                          styles.bgColor,
                          ' mt-2 p-2.5 flex-1 text-white outline-none rounded-[6px] ',
                        ].join(' ')}
                      >
                        {`Yes`}
                      </button>

                      <button
                        onClick={() => {
                          setShowModal(false);
                        }}
                        className={[
                          'bg-[red]',
                          ' mt-2 p-2.5 flex-1 text-white outline-none rounded-[6px] ',
                        ].join(' ')}
                      >
                        {`No`}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
